import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../config/store/rootReducer';
import useGetCurrentLanguage from './useGetCurrentLanguage';
import { setCurrentLanguage, setLanguages } from '../store/actions';
import { Languages } from '../interfaces/Languages';

/**
 * Initialize the language (in the Redux store) based on the booking's event configuration
 */
function useInitializeLanguage() {
  const dispatch = useDispatch();
  const language = useGetCurrentLanguage();
  const boutiqueLanguage = useSelector((state: RootState) => state.booking.booking?.boutique.language);
  const bookingSessionLanguage = useSelector((state: RootState) => state.booking.booking?.session?.language);
  const bookingGuestLanguage = useSelector((state: RootState) => state.booking.guest?.language);
  const bookingLanguages = useSelector((state: RootState) => state.booking.booking?.languages);

  useEffect(() => {
    if (Array.isArray(bookingLanguages)) {
      dispatch(setLanguages(bookingLanguages as Languages[]));
    }

    if (
      !bookingSessionLanguage &&
      !bookingGuestLanguage &&
      boutiqueLanguage &&
      bookingLanguages?.includes(boutiqueLanguage) &&
      Object.values<string>(Languages).includes(boutiqueLanguage) &&
      boutiqueLanguage !== language
    ) {
      dispatch(setCurrentLanguage(boutiqueLanguage as Languages));
    } else if (bookingLanguages && !bookingLanguages?.includes(language)) {
      dispatch(setCurrentLanguage(bookingLanguages[0] as Languages));
    }
  }, [boutiqueLanguage, bookingSessionLanguage, bookingGuestLanguage]);
}

export default useInitializeLanguage;
